window.portalModule.directive "rescheduleDisclaimer", ['$log', ($log) ->
  restrict: "E"
  scope:
    feedItem: '='

  link: (scope, element, attrs) ->

  templateUrl: 'portal/appointments/modals/reschedule/reschedule-disclaimer/reschedule-disclaimer-directive-template.html'
]